import { range } from 'lodash';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import { mapActions, mapGetters } from 'vuex';
import { BiggestGainsLoader as biggestGainsLoader } from '@/components/content-loader';
import marketBiggestGainsElement from '@/components/market/market-biggest-gains-element/market-biggest-gains-element.vue';

const REFRESH_ENABLED = true;
const REFRESH_INTERVAL = 10 * 60 * 1000;

export default {
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide,
    marketBiggestGainsElement,
    biggestGainsLoader,
  },
  props: {
    extended: { type: Boolean, default: false },
  },
  data() {
    return {
      isComponentReady: false,
      activeIndex: 0,
      interval: null,
      swiperInstance: null,
      swiperModules: [Autoplay],
      swiperOptions: {
        spaceBetween: 0,
        autoplay: { enabled: true, delay: 10 * 1000 },
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('widgets', ['getWidget']),
    gainsData() {
      return this.getWidget('biggest-gains').data || [];
    },
    lossesData() {
      return this.getWidget('biggest-losses').data || [];
    },
    classModifiers() {
      return {
        'market-biggest-gains': true,
        'market-biggest-gains--extended': this.extended,
      };
    },
    dummyComponents() {
      if (this.isLayoutMobile) return range(0, 1);
      return range(0, 2);
    },
    items() {
      const results = [];
      if (this.isLayoutDesktop) {
        if (this.gainsData.length) results.push(this.gainsData[0]);
        if (this.lossesData.length) results.push(this.lossesData[0]);
      } else {
        if (this.gainsData.length) results.push(this.gainsData);
        if (this.lossesData.length) results.push(this.lossesData);
      }
      return results;
    },
    shouldShowMobileSlider() {
      return this.items.length > 0 && !this.isLayoutDesktop;
    },
    shouldShowDesktopList() {
      return this.items.length > 0 && this.isLayoutDesktop;
    },
    prevArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--left': true,
      };
    },
    nextArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--right': true,
      };
    },
  },
  methods: {
    ...mapActions('widgets', ['fetchBiggestGains', 'fetchBiggestLoss']),
    onSwiperReady(swiperInstance) {
      this.swiperInstance = swiperInstance;
    },
    onTransitionStart(swp) {
      this.activeIndex = swp.activeIndex;
    },
    prevSlide() {
      this.swiperInstance.slidePrev();
    },
    nextSlide() {
      this.swiperInstance.slideNext();
    },
    fetchData() {
      Promise.all([this.fetchBiggestGains(), this.fetchBiggestLoss()]).then(() => {
        this.isComponentReady = true;
      });
    },
  },
  mounted() {
    this.fetchData();
    if (REFRESH_ENABLED) {
      this.interval = setInterval(() => {
        this.fetchData();
      }, REFRESH_INTERVAL);
    }
  },
  beforeUnmount() {
    if (this.interval) clearInterval(this.interval);
  },
};
